import React from 'react';
import {useNavigate} from "react-router-dom";
import {Button, Typography, Box} from '@mui/material';

import MobileDevicesImg from '../../../../assets/images/other/home/mobile-devices.png';
import {theme} from "../../../../utils";
import {homeStyles} from "../../home.helper";
import {aiToolsInfoCardStyles} from "../aIToolsInfoCard/aiToolsInfoCard-helpers";

export const EducationHubInfoCard = () => {
    const navigate = useNavigate();
    return (
        <Box sx={{...aiToolsInfoCardStyles.container, backgroundColor: '#4B69F133'}}>
            <Typography
                sx={{...aiToolsInfoCardStyles.sectionHeading, fontSize: "40px"}}>
                Advance Your Understanding<br/> of Geographic Atrophy
            </Typography>

            <Button
                onClick={() => navigate("/education-hub")}
                variant="contained"
                sx={aiToolsInfoCardStyles.btnContainer}>
                <Typography sx={{...theme.typography.components.montseratButtonContainedLabel, fontSize: "16px", textTransform: "none"}}>
                    {"Start learning about Geographic Atrophy"}
                </Typography>
            </Button>

            <Typography variant="body2" sx={{...aiToolsInfoCardStyles.text, fontWeight:400, fontSize:'22px', mt:'10px'}}>
                Enhance your GA expertise with insights<br/> that may strengthen detection,<br/> assessment, and management
            </Typography>

            <Box
                component='ul'
                sx={{
                    maxWidth: '565px',
                    mx: 'auto',
                    paddingLeft: '1.5em',
                    margin: 0,
                    listStylePosition: 'outside',
                    ...homeStyles.bulletList,
                }}
            >
                <li>
                    <Typography sx={homeStyles.listItem}>
                        Understand <strong>how GA develops</strong> and the <strong>early<br/>clues</strong> that may signal
                        progression risk
                    </Typography>
                </li>
                <li>
                    <Typography sx={homeStyles.listItem}>
                        Recognize <strong>how GA appears on OCT, CFP, and<br />FAF</strong> and what may point to disease
                        trajectory
                    </Typography>
                </li>
                <li>
                    <Typography sx={homeStyles.listItem}>
                        Clarify <strong>C3/C5 complement dysregulation</strong> and<br /> its role in GA biology
                    </Typography>
                </li>
                <li>
                    <Typography sx={{...homeStyles.listItem, mb:0}}>
                        Apply <strong>practical management tools</strong> to counsel<br />
                        patients, coordinate referrals, and guide<br />
                        monitoring
                    </Typography>
                </li>
            </Box>

            <img src={MobileDevicesImg} style={{maxHeight: '550px', marginLeft: 'auto', marginRight: 'auto'}}
                 alt={"Mobile devices"}/>
        </Box>
    );
};